import { blue } from '@material-ui/core/colors';

import { LayerProps } from 'react-map-gl';

const dataLayer: LayerProps = {
  id: 'lieuucation-viewed',
  type: 'line',
  source: 'lieuucations',
  ...{ 'source-layer': 'lieuucations' },
  beforeId: 'road-label',
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  },
  paint: {
    'line-color': blue[200],
    'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 15, 4],
    'line-opacity': ['interpolate', ['linear'], ['zoom'], 9, 0.75, 15, 1]
  }
};

export default dataLayer;
